
import AdminNavBar from '@/components/AdminNavBar/AdminNavBar.vue';
import {show_error} from '@/utils/validations.js';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { format_date } from '@/utils/date_formatter';
import { useToast } from "@/components/Toast/useToast";

export default {
  name: 'ViewClientAdmin',
  setup() {
    const { showSuccess, showError, showWarning } = useToast();
    
    return {
      showSuccess,
      showError,
      showWarning
    };
  },
  components: {
    AdminNavBar,
  },
  data: () => ({
    admin_data: [],
    get_user_id: '',
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    
  }),
  methods: {
    formatDate(date) {
      return format_date(date);
    },
    get_admin_client_details(user_id) {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      if (!BASE_URL) {
        show_error('.error-message', 'Server configuration error. Please try again later.');
        return;
      }
      const GET_USER_URL = `${BASE_URL}/verify_api/verify_admin_api/view_user_api/${user_id}`;

      $.ajax({
        method: "GET",
        url: GET_USER_URL,
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {

        },
        success: (response) => {
            this.get_user_id = response.user[0].id
            this.first_name = response.user[0].first_name;
            this.last_name = response.user[0].last_name;
            this.email = response.user[0].email;
            this.phone_number = response.user[0].phone_number;
            this.date_joined =  response.user[0].date_joined.split('T')[0];
        },
        error: () => {
          this.showError('Failed to load user details. Please try again.');
        }
      });
    },
    edit_user(get_user_id) {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      if (!BASE_URL) {
        show_error('.error-message', 'Server configuration error. Please try again later.');
        return;
      }
      const EDIT_USER_URL = `${BASE_URL}/verify_api/verify_admin_api/edit_user_api/${get_user_id}`;
      const FORM_DATA = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        phone_number: this.phone_number
      };

      $.ajax({
        method: "POST",
        url: EDIT_USER_URL,
        data: JSON.stringify(FORM_DATA),
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {

        },
        success: (response) => {
          this.showSuccess(response.message || 'User updated successfully');
        },
        error: (error) => {
          this.showError(error.responseJSON?.error || 'Failed to update user');
        }
      })
    },
  },
  computed: {
    filteredData() {
      return this.data[this.currentTab];
    }
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
  }
    let user_id= this.$route.params.user_id;
    this.get_admin_client_details(user_id);
  }
};
